import * as React from "react"
import { SVGProps } from "react"

export const MenuIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    fill="none"
    viewBox="0 0 40 40"
    {...props}
  >
    <path fill="currentColor" d="M11 26v-2h18v2H11zm0-5v-2h18v2H11zm0-5v-2h18v2H11z" />
  </svg>
)
